import _ from 'underscore'
import EditClassViewTemplate from '../templates/edit-class.tpl'
import messages from '../messages'
import Alert from '../helpers/alert'
import Backbone from 'backbone'

const EditClassView = Backbone.View.extend({
    tagName: 'div',
    id: 'form-view',
    edit: true,
    inputSettings: 'autocomplete=off autocorrect=off autocapitalize=off spellcheck=false',
    events: {
        'click .close': 'close',
        'click .submit': 'updateClass',
        'click .delete': 'deleteClass',
    },
    initialize() {
        this.template = _.template(EditClassViewTemplate)
    },
    render() {
        this.$el.html(this.template(this.model.toJSON()))
        return this
    },
    updateClass() {
        // set the class name
        const name = this.$el.find('#name').val()

        new Promise((resolve, reject) => {
            // checks if name is blank
            if (name.trim() === '') {
                reject(messages.MSG_CLASS_NAME_BLANK)
            }
            resolve()
        })
            .then(() => this.model.update(name))
            .then(() => this.close())
            .then(() => new Promise((resolve) => resolve()))
            .catch(Alert)
    },
    deleteClass() {
        // default this to the delete class message
        let message = messages.MSG_CONFIRM_DELETE_CLASS

        // display the warning
        const conf = confirm(message)

        // if they agree delete the class
        if (conf) {
            this.model.delete()
                .then(() => {
                    return this.close()
                })
        }
    },
    close() {
        this.remove()
        this.unbind()
    }
})

export default EditClassView
